/** @file nodeAt: the node under a viewport point (joint head, else bone axis), or null. */
import { drawableAt } from './drawableAt';
import { jointsFor } from './jointsFor';
import { pickNode, type PickedNode } from './pickNode';
import type { ViewportCtx } from './viewportCtx';

/** The node under `p` (target pixels): by joint / bone when joints are shown, else by the drawn part; null before the puppet is drawn. */
export function nodeAt(ctx: ViewportCtx, p: readonly [number, number]): PickedNode | null {
  const puppet = ctx.puppet();
  if (puppet === null || ctx.scene === null) return null;
  // joints hidden (the default, like the original's editor): a click on a part's picture picks its bone; joints
  // shown: the joint head or bone axis under the point first, the picture under it otherwise
  const byJoint = ctx.store.getState().camera.joints ? pickNode(jointsFor(ctx), puppet.instance.state().pose, ctx.scene.camera.view(), p) : null;
  return byJoint ?? drawableAt(ctx, p);
}
